import React, {Component, Fragment} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import axios from 'axios';
import {formValueSelector, reduxForm} from 'redux-form';

import {sendToParent, TYPES} from '../../common/events';
import AppBlock from '../components/AppBlock';
import Title from '../components/Form/Title';
import CheckboxInput from '../components/Form/CheckboxInput';
import {API_URL} from '../../common/configs';

const FORM_NAME = 'agreement-form';

const clickEventListener = function(event) {
  if (event.target.nodeName.toUpperCase() === 'BODY') {
    sendToParent(TYPES.HIDE_POPUP);
  }
};

class Agreement extends Component {
  constructor(props) {
    super(props);

    this.sendAnswer = this.sendAnswer.bind(this);
    this.consent_id = props.location.query.consent_id;
    this.project_id = props.location.query.projectId;
    this.token = props.location.query.token;
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidMount() {
    if (window.self === window.top) {
      document.body.className += ' with-bg';
    }
    document.addEventListener('click', clickEventListener);
  }

  // eslint-disable-next-line class-methods-use-this
  componentWillUnmount() {
    document.removeEventListener('click', clickEventListener);
  }

  sendAnswer() {
    const {
      agreement,
      intl,
      xl: {consentUrl}
    } = this.props;
    const params = {
      projectId: this.project_id,
      token: this.token,
      consentStateKey: this.consent_id,
      accept_consent: consentUrl ? agreement : null
    };

    axios
      .put(`${API_URL}social/consent`, params)
      .then(response => {
        this.setState({isLoading: false, showFooter: false});
        if (typeof window !== 'undefined') {
          window.top.location.href = response.data.url;
        }
      })
      .catch(error => {
        let errorMsg = error.message;
        if (error.response) {
          const {code} = error.response.data.error;
          if (intl.messages[`http.${code}`]) {
            errorMsg = intl.messages[`http.${code}`];
          }
        }
        this.setState({
          isLoading: false,
          error: errorMsg
        });
      });
  }

  render() {
    const {
      intl,
      location,
      xl: {privacyUrl, consentUrl, cookieUrl}
    } = this.props;

    return (
      <div className="content">
        <AppBlock>
          <Title title={intl.messages['agreement.title']} titleClassName="title--error" />

          <div className="block-content block-content--horizontal-center">
            <div className="agreement-page">
              {intl.messages['agreement.text']}

              {cookieUrl && (
                <Fragment>
                  <FormattedMessage
                    id="agreement.cookie"
                    values={{
                      cookie: (
                        <a
                          id="cookie_link"
                          href={cookieUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {intl.messages['agreement.cookie.link']}
                        </a>
                      )
                    }}
                  />
                  <br />
                </Fragment>
              )}

              {privacyUrl && (
                <FormattedMessage
                  id="agreement.privacy"
                  values={{
                    privacy: (
                      <a
                        id="privacy_link"
                        href={privacyUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {intl.messages['agreement.privacy.link']}
                      </a>
                    )
                  }}
                />
              )}

              {consentUrl && (
                <CheckboxInput
                  name="agreement"
                  label={
                    <FormattedMessage
                      id="agreement.consent.checkbox"
                      values={{
                        consent: (
                          <a
                            id="consent_link"
                            href={consentUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {intl.messages['agreement.consent.link']}
                          </a>
                        )
                      }}
                    />
                  }
                />
              )}

              <div className="buttons">
                <Link
                  to={{
                    pathname: '/',
                    search: location.search
                  }}
                >
                  <button type="submit" className="form-button button-outline">
                    {intl.messages['agreement.close']}
                  </button>
                </Link>

                <button
                  type="submit"
                  className="form-button button-with-bg"
                  onClick={this.sendAnswer}
                >
                  {intl.messages['agreement.continue']}
                </button>
              </div>
            </div>
          </div>
        </AppBlock>
      </div>
    );
  }
}

Agreement.propTypes = {
  intl: PropTypes.object.isRequired,
  xl: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  agreement: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    ...state,
    agreement: formValueSelector(FORM_NAME)(state, 'agreement') || false,
    form: FORM_NAME
  };
}

export default injectIntl(connect(mapStateToProps)(reduxForm()(Agreement)));



// WEBPACK FOOTER //
// ./pages/Agreement.jsx